import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

/** Leaf-like SVG path for organic shapes */
const LeafShape = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 200 200" className={className} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M100 10 C140 40, 180 80, 170 130 C160 170, 120 190, 100 190 C80 190, 40 170, 30 130 C20 80, 60 40, 100 10Z"
      fill="currentColor"
    />
  </svg>
);

/** Rounded organic blob SVG */
const BlobShape = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 200 200" className={className} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M45,-62C56.5,-53.8,62.8,-38.3,67.2,-22.5C71.6,-6.7,74.1,9.3,68.7,22.2C63.3,35.1,50,44.8,36.7,53.5C23.4,62.2,10,69.8,-4.6,75.7C-19.2,81.5,-35,85.5,-47.5,78.2C-60,70.9,-69.2,52.3,-73.9,33.7C-78.5,15.2,-78.5,-3.3,-73.4,-19.5C-68.3,-35.7,-58.1,-49.6,-44.8,-57.2C-31.5,-64.8,-15.7,-66.1,0.7,-67C17.2,-67.9,33.5,-70.2,45,-62Z"
      transform="translate(100 100)"
      fill="currentColor"
    />
  </svg>
);

/** Circle ring */
const RingShape = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 200 200" className={className} xmlns="http://www.w3.org/2000/svg">
    <circle cx="100" cy="100" r="80" fill="none" stroke="currentColor" strokeWidth="2" />
  </svg>
);

/** Dotted arc */
const DottedArc = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 200 100" className={className} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 90 Q100 -20 190 90"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeDasharray="4 8"
    />
  </svg>
);

/** Parallax wrapper — moves children at a different scroll speed */
export const ParallaxLayer = ({
  children,
  speed = 0.2,
  className,
}: {
  children: React.ReactNode;
  speed?: number;
  className?: string;
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [speed * -100, speed * 100]);

  return (
    <motion.div ref={ref} style={{ y }} className={className}>
      {children}
    </motion.div>
  );
};

export { LeafShape, BlobShape, RingShape, DottedArc };
